import moment from 'moment'

import { VertSpacerXS } from '@apps-common/components/layout'

import { useTheme } from '@apps-common/hooks/useTheme'
import { INotificationLogModel } from '@apps-common/types/portal/notification'
import { useMemo } from 'react'
import { notificationIcon } from './Icons'

interface IProps {
  model: INotificationLogModel
  lastViewedId: number
}

export const NotificationCard = ({ model, lastViewedId }: IProps) => {
  const { id, entityId, title, msg, type, appName, timeStamp } = model
  const { isUsingDarkMode, themeMode } = useTheme()

  const timestamp = useMemo(() => moment(timeStamp).local().format('ddd Do MMM hh:mm:ss'), [timeStamp])
  const isNew = useMemo(() => id > lastViewedId, [lastViewedId])

  return (
    <div className='relative overflow-hidden flex items-center justify-between bg-surface text-text border border-border rounded-[30px] px-5 py-4'>
      <div className='absolute top-3 right-4 flex flex-col items-center justify-center'>{notificationIcon(type, isUsingDarkMode)}</div>
      <div className=' flex flex-col gap-[7px]'>
        <p className='jost-light text-[0.8em] opacity-70 relative flex items-center justify-start gap-1'>
          {isNew && <div className='rounded-full w-2 h-2 bg-info' />}
          {timestamp}
        </p>
        <VertSpacerXS />
        <p className='jost text-[0.75rem]'>{title}</p>
        <p className='jost-light text-[0.9rem]'>{msg}</p>
      </div>
    </div>
  )
}
